import React from "react"
import { useHistory } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  SwipeableDrawer,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core"
import MenuIcon from "@material-ui/icons/Menu"
import AccountCircle from "@material-ui/icons/AccountCircle"
import clsx from "clsx"
import { useTranslation } from "react-i18next"
import PropTypes from 'prop-types';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';
import axios from 'axios' 
import config from '../configure' 
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Login from "../components/Login"

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  list: {
    width: 250,
  },
  test: {
    visible: "false",
  },
}))

var student_information = '';
var stdHist = {}

export default function MenuAppBar(props) {
  const ANCHOR = "left"
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [anchor, setAnchor] = React.useState(false)
  const { t, i18n } = useTranslation()
  const [openDialog, setOpenDialog] = React.useState(false);   
  const [loadHist, setLoadHist] = React.useState(false);   

  let history = useHistory()

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };  

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const changeLanguage = () => {
    setAnchorEl(null)
    i18n.language === "th" ? i18n.changeLanguage("en") : i18n.changeLanguage("th")   
  }

  function handleLogin() {
    if (localStorage.getItem("token")) {   
      Logout()  
    } else {
      Login()
    }
  }

  function Logout() {    
    history.push("/logout")
    setAnchorEl(null)    
  }

  const handleClose = () => {
    setAnchorEl(null)
    
  }

  const handleClickedPerHist = (state) => { 
    setAnchorEl(null)     

    const AuthStr = 'Bearer '.concat(localStorage.getItem('token'));  
    
    if (!loadHist) {
      axios({            
        method: 'get',
        url: `${config.API_URL}/PerHist`,
        headers: { Authorization: AuthStr }      
      }).then(res => {
        stdHist = res.data
        stdHist.facpe = stdHist.facpe.toUpperCase()
        student_information = 
          <>
            {i18n.language === "th" ?
              <>
                <b>{t("NAME")}</b> : <b>{stdHist.namet}</b><br/> 
                <b>{stdHist.facpt}</b> : <b>{stdHist.fact}</b><br/>            
                <b>{t("MAJOR")}</b> : <b>{stdHist.mat}</b><br/>            
                <b>{t("DEGREE")}</b> : <b>{stdHist.denlt}</b><br/>                       
                <b>{t("CURRICULUM YEAR")}</b> : <b>{stdHist.cy}</b><br/> 
              </>
            :
              <>
                <b>{t("NAME")}</b> : <b>{stdHist.namee}</b><br/> 
                <b>{stdHist.facpe}</b> : <b>{stdHist.face}</b><br/>            
                <b>{t("MAJOR")}</b> : <b>{stdHist.mae}</b><br/>            
                <b>{t("DEGREE")}</b> : <b>{stdHist.denle}</b><br/>                       
                <b>{t("CURRICULUM YEAR")}</b> : <b>{stdHist.cy}</b><br/> 
              </>   
            }  
          </>  
        
        setOpenDialog(true);   
        setLoadHist(true)              
      }).catch( err => {
        if (err.response && err.response.status === 401) {          
          Login()
        }  
      })    
    } else if (loadHist) {
      student_information = 
      <>
        {i18n.language === "th" ?
          <>
            <b>{t("NAME")}</b> : <b>{stdHist.namet}</b><br/> 
            <b>{stdHist.facpt}</b> : <b>{stdHist.fact}</b><br/>            
            <b>{t("MAJOR")}</b> : <b>{stdHist.mat}</b><br/>            
            <b>{t("DEGREE")}</b> : <b>{stdHist.denlt}</b><br/>                       
            <b>{t("CURRICULUM YEAR")}</b> : <b>{stdHist.cy}</b><br/> 
          </>
        :
          <>
            <b>{t("NAME")}</b> : <b>{stdHist.namee}</b><br/> 
            <b>{stdHist.facpe}</b> : <b>{stdHist.face}</b><br/>            
            <b>{t("MAJOR")}</b> : <b>{stdHist.mae}</b><br/>            
            <b>{t("DEGREE")}</b> : <b>{stdHist.denle}</b><br/>                       
            <b>{t("CURRICULUM YEAR")}</b> : <b>{stdHist.cy}</b><br/> 
          </>   
        }  
      </>      
      setOpenDialog(true);   
    }
  }

  const handleClickedAcad = () => { 
    history.push("/AcademicResult")
  }
  
  const handleClickedGpaPredict = () => {
    history.push("/GpaPredict")    
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }
    setAnchor(open)    
  }

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem
          button
          key={"ผลการศึกษา"}
          divider={true}
          disabled={localStorage.getItem("token") ? false : true}
          onClick={handleClickedAcad}
        >          
          <ListItemText primary={t("Academic Result")} />
        </ListItem>

        <ListItem
          button
          key={"คำนวณเกรด"}
          disabled={localStorage.getItem("token") ? false : true}
          onClick={handleClickedGpaPredict}
        >          
          <ListItemText primary={t("Advance grade calculation")} />
        </ListItem>        

      </List>
    </div>
  )

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);  

  return (
    <div className={classes.root} >        
      <React.Fragment>  
        <HideOnScroll {...props}>          
          <AppBar>        
            <Toolbar>
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(ANCHOR, true)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>            
                {t("For Student")}
              </Typography>

              <div>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleLogin} divider={true}>
                    {" "}
                    {localStorage.getItem("token") ? "Logout" : "Login"}
                  </MenuItem>
                  <MenuItem
                    onClick={handleClickedPerHist}
                    divider={true}
                    disabled={localStorage.getItem("token") ? false : true}
                  >
                    {t("Student Information")}
                  </MenuItem>
                  <MenuItem onClick={() => changeLanguage()}>TH / EN</MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>
        </HideOnScroll>
      </React.Fragment>
      <Toolbar />
      <React.Fragment key={ANCHOR}>
        <SwipeableDrawer
          anchor={ANCHOR}
          open={anchor}
          onClose={toggleDrawer(ANCHOR, false)}
          onOpen={toggleDrawer(ANCHOR, true)}
        >
          {list(anchor)}
        </SwipeableDrawer>
      </React.Fragment>

      <Dialog
        open={openDialog}        
        onClose={handleCloseDialog}
        scroll= 'paper'
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">{t("Student Information")}</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >{student_information}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
          {t("CLOSE")}
          </Button>
        </DialogActions>
      </Dialog>

    </div>        
  )
}